import { TimePicker } from '@mui/lab'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import { TextField, Box } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import classNames from 'classnames'
import { es } from 'date-fns/locale'
import { useField, useFormikContext } from 'formik'

import { ClockIcon } from 'src/components/shared/ui/Icons'
import { fieldsStyles as styles } from 'src/components/shared/ui/form/fields/fieldsStyles'
import { theme } from 'src/providers/ThemeProvider'

type Props = {
  id: string
  label: string
  disabled?: boolean
  required?: boolean
  placeholder?: string
}

const stylesTimePicker = {
  ...styles.input,

  '& .MuiOutlinedInput-input': {
    padding: 0
  },

  '& .MuiOutlinedInput-root': {
    borderBottom: '0!important'
  },

  '& .MuiSvgIcon-root': {
    fill: theme.corporate.primaryColor
  }
}

function WrapperClockIcon(): JSX.Element {
  return (
    <Box className="wrapperRightIcon" display="flex" justifyContent="center" alignItems="center">
      <ClockIcon />
    </Box>
  )
}

function TimePickerField(props: Props): JSX.Element {
  const { id, label, disabled, required, placeholder = 'hh:mm' } = props
  const [fieldInfo, meta] = useField(id)
  const { setFieldValue } = useFormikContext()
  const inputClassNames = classNames({
    disabled,
    required,
    error: meta.error
  })

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={es}>
        <InputLabel id={`${id}-label`} className={inputClassNames}>
          {label}
        </InputLabel>
        <TimePicker
          components={{
            OpenPickerIcon: WrapperClockIcon
          }}
          className={inputClassNames}
          mask="__:__"
          inputFormat="HH:mm"
          value={fieldInfo.value}
          onChange={value => {
            setFieldValue(id, value ?? null, true)
          }}
          renderInput={params => (
            <TextField
              className={inputClassNames}
              sx={stylesTimePicker}
              {...params}
              inputProps={{
                ...params.inputProps,
                placeholder
              }}
            />
          )}
        />
        <Box component="span" sx={styles.helpText}>
          {meta.error}
        </Box>
      </LocalizationProvider>
    </>
  )
}

export default TimePickerField
